var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillPayColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6171 11.0988C10.6145 9.08588 7.36241 9.08159 5.35377 11.0902L2.90039 13.9729L7.14132 17.7863L8.20991 16.8548C8.56554 16.5454 9.24165 16.2926 9.71382 16.2926H13.9822C14.5623 16.2926 15.139 16.2129 15.6969 16.0561L20.2806 14.7699L24.8583 12.2282C25.3545 11.8812 24.5609 9.65316 22.2275 10.5461C20.9953 11.02 19.3902 11.5384 18.6944 12.0226L15.2084 12.6524C14.7577 12.7895 14.1193 12.6267 13.7902 12.2908L12.6171 11.0988Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6976 16.0561L20.2813 14.7699L24.859 12.2282C25.3551 11.8812 24.5616 9.65317 22.2282 10.5461C20.996 11.02 19.3909 11.5384 18.6951 12.0226L15.2091 12.6524C14.7584 12.7895 14.12 12.6267 13.7909 12.2908L12.6186 11.098C12.191 10.6678 11.6991 10.349 11.1816 10.1022C9.5834 9.81427 7.49935 10.3421 6.26366 11.5795L4.5498 13.2934L7.55419 17.4281L8.21231 16.8548C8.56794 16.5454 9.24405 16.2926 9.71536 16.2926H13.9846C14.563 16.2926 15.1389 16.2138 15.6976 16.0561Z",
    fill: "#FFE0B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7613 12.8829H11.4277L11.54 10.3121H14.7355C17.7613 10.3121 17.7613 12.4545 17.7613 12.8829Z",
    fill: "#FFE0B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.4538L3.47909 12.9722L8.32673 17.8189L5.84935 20.3015L1 15.4538Z",
    fill: "#00DCF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47798 12.9714L1 15.4536L1.60705 16.0596L4.08503 13.5774L3.47798 12.9714Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85001 20.3002L8.32764 17.8176L7.11457 16.607L4.63694 19.0895L5.85001 20.3002Z",
    fill: "#00DCF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4884 4.48397C18.4884 6.40665 16.9281 7.96793 15.0045 7.96793C13.0795 7.96793 11.5205 6.40665 11.5205 4.48397C11.5205 2.56035 13.0795 1 15.0045 1C16.9281 1 18.4884 2.56035 18.4884 4.48397Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4889 4.48391C18.4889 3.42618 18.0151 2.4804 17.2705 1.84121C16.799 1.60244 16.2671 1.46448 15.7017 1.46448C13.7767 1.46448 12.2178 3.02483 12.2178 4.94844C12.2178 6.00571 12.6911 6.95196 13.4353 7.59115C13.9077 7.82991 14.4396 7.96788 15.0049 7.96788C16.9286 7.96788 18.4889 6.4066 18.4889 4.48391Z",
    fill: "#FCB701"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2701 1.84115C17.1995 1.80492 17.1243 1.77612 17.0504 1.745C17.3728 2.27177 17.5595 2.89145 17.5595 3.5548C17.5595 5.47748 15.9992 7.03876 14.0756 7.03876C13.5957 7.03876 13.1419 6.93425 12.7266 6.75819C12.9179 7.07175 13.1576 7.35279 13.435 7.59109C13.9074 7.82986 14.4393 7.96782 15.0046 7.96782C16.9282 7.96782 18.4886 6.40654 18.4886 4.48386C18.4886 3.42612 18.0152 2.48034 17.2701 1.84115Z",
    fill: "#FCB701"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8599 5.82103C13.9145 5.89389 14.3399 6.35676 14.9313 6.35676C15.5227 6.35676 16.0028 5.90621 16.0028 5.28531C16.0028 4.56369 15.1879 4.29529 14.9313 4.21386C14.6747 4.13243 14.1277 3.85385 14.1277 3.41028C14.1277 2.9667 14.4877 2.60669 14.9313 2.60669C15.219 2.60669 15.5726 2.75562 15.7349 2.8783",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9312 6.89229V6.35657",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9312 2.60665V2.07092",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0428 1.11464C14.3256 1.03964 14.6235 1 14.9304 1C16.8532 1 18.4127 2.55949 18.4127 4.4822C18.4127 6.40492 16.8532 7.96441 14.9304 7.96441C13.0077 7.96441 11.4482 6.40492 11.4482 4.4822C11.4482 3.28325 12.0552 2.22466 12.9777 1.5984",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8599 5.82103C13.9145 5.89389 14.3399 6.35676 14.9313 6.35676C15.5227 6.35676 16.0028 5.90621 16.0028 5.28531C16.0028 4.56369 15.1879 4.29529 14.9313 4.21386C14.6747 4.13243 14.1277 3.85385 14.1277 3.41028C14.1277 2.9667 14.4877 2.60669 14.9313 2.60669C15.219 2.60669 15.5726 2.75562 15.7349 2.8783",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9312 6.89229V6.35657",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9312 2.60665V2.07092",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0428 1.11464C14.3256 1.03964 14.6235 1 14.9304 1C16.8532 1 18.4127 2.55949 18.4127 4.4822C18.4127 6.40492 16.8532 7.96441 14.9304 7.96441C13.0077 7.96441 11.4482 6.40492 11.4482 4.4822C11.4482 3.28325 12.0552 2.22466 12.9777 1.5984",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8599 5.82103C13.9145 5.89389 14.3399 6.35676 14.9313 6.35676C15.5227 6.35676 16.0028 5.90621 16.0028 5.28531C16.0028 4.56369 15.1879 4.29529 14.9313 4.21386C14.6747 4.13243 14.1277 3.85385 14.1277 3.41028C14.1277 2.9667 14.4877 2.60669 14.9313 2.60669C15.219 2.60669 15.5726 2.75562 15.7349 2.8783",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9312 6.89229V6.35657",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9312 2.60665V2.07092",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0428 1.11464C14.3256 1.03964 14.6235 1 14.9304 1C16.8532 1 18.4127 2.55949 18.4127 4.4822C18.4127 6.40492 16.8532 7.96441 14.9304 7.96441C13.0077 7.96441 11.4482 6.40492 11.4482 4.4822C11.4482 3.28325 12.0552 2.22466 12.9777 1.5984",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.286 10.2956C9.39554 9.28275 6.99282 9.57391 5.39684 11.1691L5.18994 11.4118",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4259 12.2502L18.3845 12.0767L20.7597 10.8436C22.7586 9.90673 24.3229 10.2655 24.5531 12.0266L19.9296 14.7514L15.4203 16.0203C14.8763 16.1738 14.3132 16.2506 13.7467 16.2506H9.61873C9.1582 16.2506 8.52582 16.4775 8.17793 16.7812L7.98438 16.8721",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.1135L3.53203 12.4554L8.84138 17.7648L6.30851 20.4228",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4288 12.9143H17.4773C17.4773 12.4972 17.4773 10.4115 14.5323 10.4115H11.4204",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillPayColor);
export default __webpack_public_path__ + "static/media/bill-pay-color.67807971341a9b38c985df02061e253a.svg";
export { ForwardRef as ReactComponent };